<template>
    <div v-if="companyId" :class="isSubComponent ? 'pt-1 pr-3 pb-1 pl-1' : 'pa-3'">
        <v-row no-gutters class="rounded-xl d-flex justify-center align-center mb-2 bg-white">
            <v-col cols="6" class="d-flex align-center">
                <v-btn
                    v-if="assistVatMode"
                    class="mx-2"
                    prepend-icon="$fa-chevron-left"
                    @click="back()"
                    size="small"
                    >Assistant TVA</v-btn
                >
                <v-btn
                    v-else-if="autoVatMode"
                    class="mx-2"
                    prepend-icon="$fa-chevron-left"
                    @click="back()"
                    size="small"
                    >TVA automatique</v-btn
                >
                <v-btn-back v-else class="mx-2" @click="back()"> </v-btn-back>
                <h3 v-if="cerfaName">{{ cerfaName }}</h3>
                <v-btn v-if="!showLeftPanel" class="ml-4" size="small" @click="showLeftPanel = true"
                    >Afficher le panneau latéral</v-btn
                >
            </v-col>
            <v-col cols="6" class="d-flex align-center justify-end px-3">
                <DeclarationManagerCheck
                    :errorsCount="errorsCount"
                    :errorMessages="errorMessages"
                />
                <DeclarationManagerInsee v-if="cerfaNumber === '2561'" />
                <v-btn
                    rounded
                    elevation="0"
                    :disabled="isDisabledSaveButton"
                    @click="save()"
                    class="mx-1"
                    size="small"
                >
                    Enregistrer
                </v-btn>
                <v-tooltip v-if="isTrainingOffer">
                    <template #activator="{ props }">
                        <v-btn
                            rounded
                            elevation="0"
                            dark
                            size="small"
                            :disabled="true"
                            class="mx-1"
                            v-bind="props"
                        >
                            {{ validAndPayTitle }}
                        </v-btn>
                    </template>
                    <p>{{ $t("training-text.normal-text") }}</p>
                </v-tooltip>
                <v-btn
                    v-else
                    rounded
                    elevation="0"
                    dark
                    size="small"
                    :disabled="isDisabledValidAndSendButton"
                    @click="validAndPay()"
                    class="mx-1"
                >
                    {{ validAndPayTitle }}
                </v-btn>
                <v-btn
                    rounded
                    elevation="0"
                    :disabled="isDisabledValidButton"
                    @click="confirmWithoutSendingDialog = true"
                    class="mx-1"
                    size="small"
                >
                    Valider sans envoyer
                </v-btn>
                <v-menu offset-y>
                    <template v-slot:activator="{ props }">
                        <v-btn-icon
                            size="large"
                            icon="$dots_vertical"
                            v-bind="props"
                            class="mx-1"
                        />
                    </template>
                    <v-list>
                        <v-list-item
                            @click="confirmDialogMiscellaneousOperation = true"
                            :disabled="!documentId && !newDocumentId"
                            v-if="!isAccountingHidden"
                        >
                            <v-list-item-title>Afficher / Modifier l'OD</v-list-item-title>
                            <template v-slot:append>
                                <v-icon size="small">$oss-edit</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item
                            @click="reComputeAccountingLines()"
                            :disabled="!isSent || isInsideClosedAccountingPeriod"
                            v-if="!isAccountingHidden"
                        >
                            <v-list-item-title>Regénérer l'OD</v-list-item-title>
                            <template v-slot:append>
                                <v-icon size="small">$fa-redo-alt</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item
                            @click="updateStatus()"
                            :disabled="!isSent || translatedStatus === 'Validée sans envoi'"
                        >
                            <v-list-item-title>Mettre à jour le statut</v-list-item-title>
                            <template v-slot:append>
                                <v-icon size="small">$fa-redo-alt</v-icon>
                            </template>
                        </v-list-item>
                        <!-- SPECIFIC -->
                        <!-- 2561 -->
                        <!-- print -->
                        <v-list-item @click="printForms()" v-if="cerfaNumber === '2561'">
                            <v-list-item-title>Imprimer les formulaires 2561TER</v-list-item-title>
                            <template v-slot:append>
                                <v-icon size="small">$oss-download</v-icon>
                            </template>
                        </v-list-item>
                        <TaxFormEDIReport
                            :disabled="!mtaeId"
                            :taxFormId="declarationId"
                            :isDeclaration="true"
                        >
                            <template #default="{ statusOk, mtaeProof }">
                                <v-list-item :disabled="!statusOk" @click="mtaeProof">
                                    <v-list-item-title
                                        >Imprimer le justificatif EDI</v-list-item-title
                                    >
                                    <template v-slot:append>
                                        <v-icon size="small">$oss-download</v-icon>
                                    </template>
                                </v-list-item>
                            </template>
                        </TaxFormEDIReport>
                        <v-list-item
                            v-if="isSent && isUserAuthorized && xml"
                            @click="downloadXMLFile()"
                        >
                            <v-list-item-title>Télécharger le fichier XML</v-list-item-title>
                            <template v-slot:append>
                                <v-icon size="small">$oss-download</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item @click="duplicate()">
                            <v-list-item-title>Dupliquer</v-list-item-title>
                            <template v-slot:append>
                                <v-icon size="small">$oss-duplicate</v-icon>
                            </template>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
        </v-row>
        <v-row no-gutters style="flex-wrap: nowrap">
            <v-col
                cols="2"
                class="mr-2"
                style="max-height: calc(100vh - 164px); overflow-y: auto"
                v-if="showLeftPanel"
            >
                <v-tabs
                    :key="tabsRefreshKey"
                    direction="vertical"
                    v-model="selectedTaxFormIndex"
                    class="mb-2 rounded-xl"
                    color="primary"
                >
                    <v-tab v-if="!loaded" class="d-flex justify-center align-center">
                        <v-progress-circular
                            indeterminate
                            size="28"
                            color="primary"
                            class="mx-auto"
                        />
                    </v-tab>
                    <!-- SPECIFIC -->
                    <!-- 2561 -->
                    <!-- beneficiaries -->
                    <template v-else v-for="(name, index) of sheetNames" :value="index">
                        <div
                            v-if="
                                cerfaNumber === '2561' &&
                                !name.includes('2561BIS') &&
                                !name.includes('2561TER')
                            "
                            class="d-flex align-center my-3 ml-3 mr-4 justify-space-between"
                        >
                            <p class="text-primary">Bénéficiaire {{ index / 3 + 1 }}</p>
                            <v-btn-trash
                                v-if="!isSent"
                                size="small"
                                @click.stop="openDialogToDeleteSheetForm(name, index)"
                            />
                        </div>
                        <v-tab :value="index" class="d-flex align-center justify-space-between">
                            <p>
                                {{ name }}
                            </p>
                            <v-btn-trash
                                v-if="getShowTrashButton(name)"
                                size="small"
                                @click.stop="openDialogToDeleteSheetForm(name, index)"
                            />
                        </v-tab>
                        <v-divider
                            v-if="index < sheetNames.length - 1 && name.includes('2561TER')"
                            class="mx-2 my-2"
                        >
                        </v-divider>
                    </template>
                    <div class="pa-2 d-flex align-center justify-center" v-if="showAddFormButton">
                        <v-btn
                            :disabled="isSent"
                            rounded
                            size="small"
                            elevation="0"
                            block
                            @click="addFormDialog = true"
                        >
                            <span class="subtitle-1 white--text">+</span>
                        </v-btn>
                    </div>
                    <!-- SPECIFIC -->
                    <!-- 2651 -->
                    <!-- add a beneficiary -->
                    <div
                        class="pa-2 d-flex align-center justify-center"
                        v-if="cerfaNumber === '2561'"
                    >
                        <v-btn
                            :disabled="isSent"
                            rounded
                            size="small"
                            elevation="0"
                            block
                            @click="addBeneficiary()"
                        >
                            Ajouter un bénéficiaire
                        </v-btn>
                    </div>
                </v-tabs>
                <DeclarationManagerInfo
                    v-if="declaration"
                    :startDate="startDate"
                    :endDate="endDate"
                    :amountDeclared="amountDeclared"
                    :paymentsInfo="paymentsInfo"
                    :translatedStatus="translatedStatus"
                    :translatedSendDate="translatedSendDate"
                    :mtaeId="mtaeId"
                    :errors="errors"
                />
                <!-- SPECIFIC -->
                <!-- 2561 -->
                <!-- declaring card -->
                <DeclarationManagerDeclaring
                    v-if="cerfaNumber === '2561'"
                    :declaring="declaring"
                    :isSent="isSent"
                    @declaring-has-been-changed="needSave = true"
                />
                <div class="d-flex justify-center align-center mt-2">
                    <v-btn size="small" @click="showLeftPanel = false">Masquer</v-btn>
                </div>
            </v-col>
            <v-col
                :cols="showLeftPanel ? 10 : 12"
                class="pa-0 flex-grow-1 flex-shrink-0 document-card"
                style="max-height: calc(100vh - 164px); overflow: auto"
            >
                <v-window v-model="selectedTaxFormIndex" :key="formsRefreshKey">
                    <v-window-item v-for="(sheet, index) of sheets" :key="index" :value="index">
                        <TaxForm
                            ref="taxForm"
                            :cerfaNumber="sheet.cerfaNumber"
                            :activeTab="formDisplayMode"
                            :sheet="sheet"
                            :loaded="loaded"
                            :enableEdition="enableEdition"
                            :isSent="isSent"
                            :readOnly="isSent"
                            @fieldUpdate="onTaxFormChanged()"
                            @additionnal-page-created="additionnalPageCreated(index)"
                        />
                    </v-window-item>
                </v-window>
            </v-col>
        </v-row>
        <oss-dialog
            v-model="confirmWithoutSendingDialog"
            title="Confirmation"
            @valid="validateWithoutSendingToMTAE()"
            validTitle="Valider sans télédéclarer"
        >
            <v-row no-gutters style="width: 750px" class="text-center">
                <b>
                    &#xca;tes-vous sûr(e) de vouloir valider la déclaration sans la télédéclarer ni
                    la payer ? Les éventuelles écritures comptables seront générées automatiquement.
                </b>
            </v-row>
        </oss-dialog>
        <oss-dialog
            v-model="confirmDialogSend"
            title="Confirmation"
            @valid="generate()"
            :validTitle="validDeclarationTitle"
        >
            <v-row no-gutters style="width: 750px" class="text-center">
                <v-col cols="12">
                    <template
                        v-if="
                            validAndPayTitle === titleValidAndSend ||
                            validAndPayTitle === titleSendEDI
                        "
                    >
                        <b> &#xca;tes-vous sûr(e) de vouloir envoyer la déclaration ? </b>
                    </template>
                    <template v-else-if="bankAccounts.length">
                        <!-- SPECIFIC -->
                        <!-- 1329AC -->
                        <!-- deposit amount -->
                        <template v-if="cerfaNumber === '1329AC' && amountToPay <= 750">
                            <b
                                >Le montant est inférieur ou égal à 750 €, vous êtes dispensé de
                                payer l'acompte, voulez-vous malgré tout réaliser un paiement ?</b
                            >
                            <div class="d-flex justify-center">
                                <v-checkbox
                                    dense
                                    v-model="showPaymentsForExempt1329AC"
                                    label="Envoyer un paiement"
                                    hide-details="auto"
                                />
                            </div>
                        </template>
                        <!-- SPECIFIC -->
                        <!-- 1329AC -->
                        <!-- deposit amount -->
                        <template
                            v-if="
                                cerfaNumber !== '1329AC' ||
                                (cerfaNumber === '1329AC' && amountToPay > 750) ||
                                showPaymentsForExempt1329AC
                            "
                        >
                            <v-row no-gutters class="mb-2">
                                <b>
                                    Montant à payer :
                                    {{ newCommonFormatCurrency(amountToPay, undefined) }}
                                </b>
                            </v-row>
                            <v-row no-gutters class="mb-4">
                                <b
                                    >Montant restant à répartir :
                                    <span
                                        :style="unaffectedPaymentAmount < 0 ? 'color: red;' : ''"
                                        >{{
                                            unaffectedPaymentAmount === 0
                                                ? newCommonFormatCurrency(
                                                      unaffectedPaymentAmount,
                                                      undefined,
                                                  )
                                                : unaffectedPaymentAmount < 0
                                                  ? unaffectedPaymentAmount +
                                                    ". Le montant du paiement ne peut pas être supérieur au montant dû."
                                                  : unaffectedPaymentAmount
                                        }}</span
                                    >
                                </b>
                            </v-row>
                            <v-row
                                no-gutters
                                v-for="(line, index) of paymentsList"
                                :key="index"
                                class="mb-2"
                            >
                                <v-col cols="1" />
                                <v-col cols="6" class="d-flex justify-center align-center pr-1">
                                    <v-select-filled
                                        v-model="line.bankAccountId"
                                        :items="bankAccounts"
                                        item-title="name"
                                        item-value="id"
                                        :item-disabled="isItemDisabled"
                                        outlined
                                        class="text-field"
                                        hide-details="auto"
                                        required
                                        label="Compte bancaire"
                                        density="compact"
                                    />
                                </v-col>
                                <v-col cols="3" class="d-flex justify-center align-center pl-1">
                                    <oss-text-field-filled
                                        v-model="line.amount"
                                        outlined
                                        dense
                                        hide-details
                                        label="Montant"
                                    />
                                </v-col>
                                <v-col cols="2" class="d-flex">
                                    <v-btn-trash
                                        class="mx-2 my-2"
                                        @click="deletePaymentLine(index)"
                                        v-if="index > 0"
                                        size="x-small"
                                    >
                                    </v-btn-trash>
                                    <v-btn-add-icon
                                        class="mx-2 my-2"
                                        @click="addPaymentLine()"
                                        v-if="index === paymentsList.length - 1"
                                        :disabled="
                                            !line.amount ||
                                            !line.bankAccountId ||
                                            paymentsList.length === bankAccounts.length
                                        "
                                        size="x-small"
                                    >
                                    </v-btn-add-icon>
                                </v-col>
                                <v-col cols="12" class="pt-4">
                                    <template v-if="!line.bankAccountId">
                                        <b style="color: red">
                                            Envoi d'un paiement impossible car aucun compte bancaire
                                            sélectionné dans la liste. L'envoi de la déclaration
                                            seule reste possible.
                                        </b>
                                    </template>
                                </v-col>
                            </v-row>
                        </template>
                    </template>
                    <template v-else>
                        <b style="color: red">
                            Envoi d'un paiement impossible car aucun compte bancaire valide
                            renseigné dans le dossier. L'envoi de la déclaration seule reste
                            possible.
                        </b>
                    </template>
                </v-col>
            </v-row>
        </oss-dialog>
        <oss-dialog
            v-model="confirmDialogMiscellaneousOperation"
            title="Modification OD"
            @valid="confirm()"
            :validTitle="'OK'"
        >
            <v-row no-gutters style="width: 750px">
                <v-col cols="12" class="d-flex justify-center">
                    <div class="pt-2 px-4 pb-2">
                        Si vous modifiez l'écriture manuellement, vous perdrez le lien entre la
                        déclaration et l'OD.
                    </div>
                </v-col>
            </v-row>
        </oss-dialog>
        <oss-dialog
            v-model="miscellaneousOperationDialog"
            :actions="actionsMiscellaneousOperation"
            @valid="miscellaneousOperationDialog = false"
        >
            <div style="width: 80vw">
                <AccountingItemEdition
                    v-if="miscellaneousOperationDialog"
                    :companyId="companyId"
                    :documentId="newDocumentId || documentId"
                    :actions="actionsMiscellaneousOperation"
                >
                </AccountingItemEdition>
            </div>
        </oss-dialog>
        <oss-dialog v-model="addFormDialog" title="Ajouter un formulaire à la déclaration">
            <v-row no-gutters class="py-1" style="width: 750px">
                <v-col cols="12">
                    <v-text-field-filled
                        v-model="searchForm"
                        label="Rechercher"
                        outlined
                        hide-details
                        density="compact"
                        append-inner-icon="$search"
                        clearable
                        @click:clear="searchForm = ''"
                    />
                </v-col>
                <v-col cols="12" style="max-height: calc(100vh - 200px); overflow-y: auto">
                    <v-list two-lines>
                        <template v-if="filteredOptionalForms.length">
                            <!-- disable to avoid duplicates -->
                            <v-list-item
                                v-for="(form, index) in filteredOptionalForms"
                                :key="index"
                                @click="formToAdd(form)"
                                two-lines
                                :disabled="shortSheetNames.includes(form.cerfa.slice(0, 5))"
                            >
                                <v-list-item-title>{{ form.cerfa }}</v-list-item-title>
                                <v-list-item-subtitle style="white-space: break-spaces">{{
                                    form.title
                                }}</v-list-item-subtitle>
                            </v-list-item>
                        </template>
                        <v-list-item v-else two-lines>
                            <v-list-item-title
                                >Aucun formulaire trouvé</v-list-item-title
                            ></v-list-item
                        >
                    </v-list>
                </v-col>
            </v-row>
        </oss-dialog>
        <oss-dialog
            v-if="toDeleteDialog"
            v-model="toDeleteDialog"
            title="Suppression formulaire(s)"
            @valid="deleteSheet()"
        >
            <div class="text-center" style="width: 750px">
                <b>
                    {{ deleteSheetTitle }}
                </b>
            </div>
        </oss-dialog>
        <oss-dialog
            v-if="ibanLimitDialog"
            v-model="ibanLimitDialog"
            title="Limite DGFIP"
            @valid="ibanLimitDialog = false"
            :validTitle="'OK'"
        >
            <v-col cols="12" class="pt-3 text-center" style="width: 750px">
                <p>
                    La DGFIP fixe le nombre de comptes bancaires maximal à trois pour les paiements.
                </p>
            </v-col>
        </oss-dialog>
        <oss-dialog
            v-model="autoDepositValidationDialog"
            v-if="autoDepositValidationDialog"
            @valid="fillAutoDepositInDeclaration()"
            @close="autoDepositValidationDialog = false"
            validTitle="Appliquer"
        >
            <div style="width: 750px">
                <v-row no-gutters class="pa-4">
                    <v-col cols="12" class="d-flex align-center justify-center">
                        <b class="text-center">
                            bobbee a trouvé le montant de l'acompte à déclarer. Souhaitez-vous
                            alimenter automatiquement le formulaire?
                        </b>
                    </v-col>
                </v-row>
            </div>
        </oss-dialog>
        <oss-dialog
            v-model="infoMillesimDialog"
            title="Millésime"
            @valid="infoMillesimDialog = false"
            validTitle="OK"
        >
            <v-row no-gutters style="width: 750px" class="d-flex justify-center">
                Pour information, le millésime utilisé pour cette déclaration est celui de 2024.
            </v-row>
        </oss-dialog>
        <oss-dialog
            v-model="declaringAlertDialog"
            title="Déclarant"
            @valid="declaringAlertDialog = false"
            validTitle="OK"
        >
            <v-row no-gutters style="width: 750px" class="d-flex justify-center">
                Veuillez remplir les informations déclarant pour envoyer la déclaration.
            </v-row>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import moment from "moment-timezone";
import gql from "graphql-tag";

import { SheetManager } from "../../../../../backend/src/common/taxform/SheetManager";
import { newCommonFormatCurrency } from "../../../../../backend/src/common/services/mathServices";
import { apolloClient } from "@/apollo.services";
import { DeclarationFront } from "@/services/declaration/DeclarationFront";
import { getPaymentsFromXml, storeVatItems } from "@/services/declaration/declarationServices";
import { getAccountingFirmFromUser } from "@/services/companyServices";
import { DialogAction } from "@/services/dialogAction";
import { User } from "@/store/store";
import { Apollo } from "@/decorators";
import TaxForm from "../TaxForm.vue";
import AccountingItemEdition from "@/views/accounting/accountingItem/Edition.vue";
import TaxFormEDIReport from "../TaxFormEDIReport.vue";
import DeclarationManagerInsee from "./DeclarationManagerInsee.vue";
import DeclarationManagerCheck from "./DeclarationManagerCheck.vue";
import DeclarationManagerInfo from "./DeclarationManagerInfo.vue";
import DeclarationManagerDeclaring from "./DeclarationManagerDeclaring.vue";
import GENERATE_DECLARATION from "@/graphql/declaration/GenerateDeclaration.gql";
import BANK_ACCOUNTS from "@/graphql/bank/BankAccounts.gql";
import VALIDATE_DECLARATION_WITHOUT_SENDING_MTAE from "@/graphql/declaration/ValidateDeclarationWithoutSendingToMTAE.gql";
import RESTORE_DOCUMENT from "@/graphql/document/RestoreDocument.gql";
import UPDATE_DECLARATION_MO from "@/graphql/declaration/UpdateDeclarationAccountingLines.gql";
import UPDATE_DECLARATIONS_STATUS from "@/graphql/declaration/UpdateDeclarationsStatus.gql";
import { Component, Provide, Prop, toNative, Vue, Watch, Hook } from "vue-facing-decorator";
import {
    DasTwoDeclaring,
    DasTwoBeneficiary,
    Declaring,
} from "@/services/declaration/declarationServices";
import { isInsideClosedAccountingPeriod } from "@/services/accountingPeriods";
import { Offer_type } from "@/types/offer.types";
import {
    VatItemAssist,
    VatItemAuto,
} from "../../../../../backend/src/common/declaration/declarationServices";
import {
    PaymentsList,
    PreviousVatCredit,
} from "../../../../../backend/src/common/types/taxformTypes";

@Component({
    components: {
        TaxForm,
        AccountingItemEdition,
        TaxFormEDIReport,
        DeclarationManagerInsee,
        DeclarationManagerCheck,
        DeclarationManagerInfo,
        DeclarationManagerDeclaring,
    },
    emits: ["back"],
})
export class DeclarationManager extends Vue {
    @Prop({ default: "" }) id: string;
    @Prop({ default: null }) propsCerfaNumber: string;
    @Prop({ default: null }) propsStartDate: string;
    @Prop({ default: null }) propsEndDate: string;
    @Prop({ default: null }) propsPreviousVatCredit: any;
    @Prop({ default: false }) assistVatMode: boolean;
    @Prop({ default: null }) propsAssistVatItems: Array<any>;
    @Prop({ default: false }) autoVatMode: boolean;
    @Prop({ default: null }) propsAutoVatItems: Array<any>;
    @Provide("taxFormFocusFromConsistencyCheck") focusSpec = "";
    @Prop({ default: false }) assistDasTwoMode: boolean;
    @Prop({ default: null }) assistDasTwoDeclaring: DasTwoDeclaring;
    @Prop({ default: null }) assistDasTwoBeneficiaries: Array<DasTwoBeneficiary>;

    selectedTaxFormIndex: number = -1;

    enableEdition: boolean = true;

    loaded: boolean = false;

    formDisplayMode: string = "TaxFormTable";

    declaration: DeclarationFront = null;

    confirmWithoutSendingDialog: boolean = false;

    confirmDialogSend: boolean = false;

    confirmDialogMiscellaneousOperation: boolean = false;

    miscellaneousOperationDialog: boolean = false;

    addFormDialog: boolean = false;

    actionsMiscellaneousOperation = {
        action: new DialogAction(),
    };

    paymentsList: PaymentsList = [{ bankAccountId: "", amount: 0 }];

    fields = {};

    declarationId: string = "";

    needSave: boolean = false;

    sheets: SheetManager[] = [];

    tabsRefreshKey: number = 0;

    formsRefreshKey: number = 0;

    dicoKeyWithFunctions = {};

    newDocumentId: string = "";

    searchForm: string = "";

    incompleteBankAccounts: any[] = [];

    sheetToDelete: { name: string; index: number } = null;

    toDeleteDialog: boolean = false;

    sheetNames: string[] = [];

    ibanLimitDialog: boolean = false;

    showLeftPanel: boolean = true;

    autoDepositValidationDialog: boolean = false;

    infoMillesimDialog: boolean = false;

    showPaymentsForExempt1329AC: boolean = false;

    declaring: Declaring = {
        cityInseeCode: "",
        postOfficeDistributor: "",
        name: "",
        email: "",
        phone: "",
        legalCategory: "",
        siret: "",
    };

    declaringAlertDialog: boolean = false;

    titleValidAndSend: string = "Valider et envoyer";
    titleSendEDI: string = "Envoi EDI";

    get declarationDB() {
        return this.declaration?.declarationDB || null;
    }

    get offerType(): Offer_type {
        return this.$store.state.offerType;
    }

    get isTrainingOffer(): boolean {
        if (this.offerType === Offer_type.TRAINING) {
            return true;
        }
        return false;
    }

    get companyId(): string {
        return this.company?.id || null;
    }

    get company() {
        return this.$store?.state?.selected_company || null;
    }

    get isSent(): boolean {
        return this.status !== "EDITION";
    }

    // SPECIFIC
    get fileMillesim(): string {
        if (this.declaration?.year) {
            return this.declaration.year;
        }
        if (!this.endDate) {
            return "2024";
        }
        let year: string = "";
        switch (this.cerfaNumber) {
            case "1329AC":
            case "2573":
            case "3310CA3":
            case "3514":
            case "3515SD":
            case "3717DDR":
            case "3519":
            case "3525BIS": {
                const validityDate: string = "01012025";
                if (moment(this.endDate).isSameOrAfter(moment(validityDate, "DDMMYYYY"), "day")) {
                    return "2025";
                }
                year = moment(this.endDate).format("YYYY");
                break;
            }
            case "1329DEF":
            case "2571": {
                const validityDate: string = "01012024";
                if (moment(this.endDate).isSameOrAfter(moment(validityDate, "DDMMYYYY"), "day")) {
                    return "2025";
                }
                year = moment(this.endDate).format("YYYY");
                break;
            }
            case "3517BCA12":
            case "3517SCA12":
            case "2572": {
                const validityDate: string = "31122024";
                if (moment(this.endDate).isSameOrAfter(moment(validityDate, "DDMMYYYY"), "day")) {
                    return "2025";
                }
                year = moment(this.endDate).format("YYYY");
                break;
            }
            default: {
                year = moment(this.endDate).format("YYYY");
                break;
            }
        }
        if (+year < 2024) {
            this.infoMillesimDialog = true;
            return "2024";
        }
        return year;
    }

    get amountToPay(): number {
        return this.declaration?.amountToPay || 0;
    }

    get status(): string {
        return this.declarationDB?.status || "EDITION";
    }

    get translatedStatus(): string {
        switch (this.status) {
            case "EDITION":
                return "En cours d'édition";
            case "SENT":
                if (!this.mtaeStatus) {
                    return "Validée sans envoi";
                }
                if (this.mtaeStatus !== "OK") {
                    return this.mtaeStatus;
                }
                return "Envoyée";
            case "ERROR":
                return this.mtaeStatus;
            default:
                return "";
        }
    }

    get isDisabledSaveButton(): boolean {
        if (this.isSent) {
            return true;
        }
        if (this.errorsCount > 0) {
            return true;
        }
        if (!this.needSave) {
            return true;
        }
        return false;
    }

    get isDisabledValidButton(): boolean {
        if (this.needSave) {
            return true;
        }
        if (this.isSent) {
            return true;
        }
        if (this.errorsCount > 0) {
            return true;
        }
        return false;
    }

    get isDisabledValidAndSendButton(): boolean {
        if (this.needSave || this.errorsCount > 0 || this.mtaeStatus) {
            return true;
        } else {
            return false;
        }
    }

    get errorMessages(): string[] {
        return this.declaration?.errorMessages || [];
    }

    get errorsCount(): number {
        if (this.errorMessages?.length) {
            return this.errorMessages.length;
        }
        return 0;
    }

    set errorsCount(data) {}

    get amountDeclared(): number {
        return this.declarationDB?.amountDeclared || 0;
    }

    get xml() {
        return this.declarationDB?.data?.file || null;
    }

    get paymentsInfo() {
        if (this.status === "SENT" && this.xml) {
            const payments = getPaymentsFromXml(this.xml);
            if (payments?.amountPaid > 0) {
                return { paymentsList: payments.paymentsList, amountPaid: payments.amountPaid };
            }
        }
        return null;
    }

    get mtaeStatus(): string {
        return this.declarationDB?.mtaeStatus || "";
    }

    get sendDate(): string | Date {
        return this.declarationDB?.date || "";
    }

    get translatedSendDate(): string {
        return this.sendDate ? moment(this.sendDate).format("DD/MM/YYYY") : "";
    }

    get mtaeId(): string {
        return this.declarationDB?.mtaeId || "";
    }

    get errors() {
        const errors = [];
        if (this.declarationDB?.mtaeData?.erreur?.length) {
            for (const err of this.declarationDB.mtaeData.erreur) {
                if (
                    !errors.some(
                        (error) => error.num === err.numErreur && error.detail === err.texte,
                    )
                ) {
                    errors.push({ num: err.numErreur, detail: err.texte });
                }
            }
        } else if (this.status === "ERROR") {
            errors.push({ num: "N/A", detail: "" });
        }
        return errors;
    }

    get cerfaName(): string {
        return this.declaration?.cerfaName || "";
    }

    get validDeclarationTitle() {
        if (
            this.paymentsList.some((pl) => pl.bankAccountId?.length && pl.amount > 0) &&
            this.validAndPayTitle !== this.titleValidAndSend &&
            this.validAndPayTitle !== this.titleSendEDI
        ) {
            return "Envoyer la déclaration et le paiement";
        }
        return "Envoyer la déclaration";
    }

    get currentUser(): User {
        return this.$store?.state?.user;
    }

    get documentId(): string {
        return this.declarationDB?.document?.id || "";
    }

    get optionalForms() {
        return this.declaration?.optionalForms || [];
    }

    get filteredOptionalForms() {
        if (this.searchForm) {
            return this.optionalForms.filter((form) => {
                return (
                    form.title.toLowerCase().includes(this.searchForm.toLowerCase()) ||
                    form.cerfa.toLowerCase().includes(this.searchForm.toLowerCase())
                );
            });
        }
        return this.optionalForms;
    }

    get isSubComponent(): boolean {
        return (
            window.location.href.includes("auto") ||
            window.location.href.includes("vatCalculationAssist")
        );
    }

    get isUserAuthorized() {
        const email = this.$store?.state?.user.email;
        if (email?.includes("@oss360.com")) {
            return true;
        }
        return false;
    }

    // SPECIFIC
    get isAccountingHidden(): boolean {
        return [
            "2777",
            "2561",
            "3519",
            "2571",
            "2573",
            "1329AC",
            "3514",
            "3525BIS",
            "3517DDR",
            "DAS2",
            "1330CVAE",
        ].includes(this.cerfaNumber);
    }

    get validAndPayTitle(): string {
        if (this.isSent && !this.mtaeStatus) {
            const endTextToPay = this.amountToPay > 0 ? " et paiement" : "";
            return "Envoi EDI" + endTextToPay;
        } else {
            const endText = this.amountToPay > 0 ? " et payer" : " et envoyer";
            return "Valider" + endText;
        }
    }

    get deleteSheetTitle(): string {
        // SPECIFIC
        // 2561
        // beneficiaries
        if (this.cerfaNumber === "2561") {
            return "Êtes-vous sûr(e) de vouloir supprimer les 3 formulaires de ce bénéficiaire ?";
        }
        // SPECIFIC
        // 3310A + 3310TER + 3310TIC
        // these forms, except complementary pages, work in groups
        const excludedPatterns: string[] = ["EX", "(", "_1X", "_2X", "_3X"];
        if (!excludedPatterns.some((pattern) => this.sheetToDelete.name.includes(pattern))) {
            if (this.sheetToDelete.name.startsWith("3310A")) {
                return "Êtes-vous sûr(e) de vouloir supprimer l'ensemble des formulaires de l'annexe 3310A ?";
            }
            if (this.sheetToDelete.name.startsWith("3310TER")) {
                return "Êtes-vous sûr(e) de vouloir supprimer l'ensemble des formulaires de l'annexe 3310TER ?";
            }
            if (this.sheetToDelete.name.startsWith("3310TIC")) {
                return "Êtes-vous sûr(e) de vouloir supprimer l'ensemble des formulaires de l'annexe 3310TIC ?";
            }
        }
        //
        return "Êtes-vous sûr(e) de vouloir supprimer ce formulaire ?";
    }

    get showAddFormButton(): boolean {
        if (!this.optionalForms) {
            return false;
        }
        if (this.optionalForms && !this.optionalForms.length) {
            return false;
        }
        return true;
    }

    get accountingPeriod() {
        return this.$store?.state?.accountingPeriod?.selectedAccountingPeriod || null;
    }

    get accountingPeriodId(): string {
        return this.accountingPeriod?.id || "";
    }

    get cerfaNumber(): string {
        return this.propsCerfaNumber
            ? this.propsCerfaNumber
            : this.declaration
              ? this.declaration.cerfaNumber
              : "";
    }

    get startDate(): string {
        return this.propsStartDate
            ? this.propsStartDate
            : this.declarationDB
              ? moment(this.declarationDB.startDate).format("YYYY-MM-DD")
              : "";
    }

    get endDate(): string {
        return this.propsEndDate
            ? this.propsEndDate
            : this.declarationDB
              ? moment(this.declarationDB.endDate).format("YYYY-MM-DD")
              : "";
    }

    get unaffectedPaymentAmount(): number {
        const affectedPaymentAmount = this.paymentsList.reduce((acc, curr) => acc + curr.amount, 0);
        const amount = this.amountToPay - affectedPaymentAmount;
        return amount;
    }

    get extraData(): (VatItemAuto | VatItemAssist)[] {
        const autoItems = this.autoVatItems || [];
        const assistItems = this.assistVatItems || [];
        return [...autoItems, ...assistItems];
    }

    get isInsideClosedAccountingPeriod() {
        if (this.declarationDB?.document?.date) {
            return isInsideClosedAccountingPeriod(this.$store, this.declarationDB.document.date);
        }
        return false;
    }

    get autoVatItems(): VatItemAuto[] {
        return this.propsAutoVatItems || this.$store?.state?.autoVatItems || null;
    }

    get assistVatItems(): VatItemAssist[] {
        return this.propsAssistVatItems || this.$store?.state?.assistVatItems || null;
    }

    // SPECIFIC
    // 2561
    // declaring condition
    get declaringIsFullyFilled(): boolean {
        if (this.cerfaNumber === "2561") {
            if (
                this.declaring?.name &&
                this.declaring?.email &&
                this.declaring?.phone &&
                this.declaring?.cityInseeCode &&
                this.declaring?.postOfficeDistributor &&
                this.declaring?.legalCategory
            ) {
                return true;
            }
            return false;
        }
        return null;
    }

    get shortSheetNames(): string[] {
        return this.sheetNames?.map((sn) => sn.slice(0, 5)) || [];
    }

    get previousVatCredit(): PreviousVatCredit {
        return this.propsPreviousVatCredit || this.$store?.state?.previousVatCredit || null;
    }

    @Watch("showPaymentsForExempt1329AC")
    onCheckboxChecked() {
        if (!this.showPaymentsForExempt1329AC) {
            this.paymentsList = [{ bankAccountId: "", amount: 0 }];
        }
    }

    @Apollo({
        query: gql`
            query CompanyDetails($id: ID!) {
                company(where: { id: $id }) {
                    id
                    profile {
                        id
                        vatBankAccount {
                            id
                            iban
                            bic
                        }
                    }
                }
            }
        `,
        variables() {
            return {
                id: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.company) {
                    this.companyDetails = data.company;
                    if (
                        this.companyDetails?.profile?.vatBankAccount?.iban?.length &&
                        this.companyDetails?.profile?.vatBankAccount?.bic?.length &&
                        this.companyDetails?.profile?.vatBankAccount?.id?.length
                    ) {
                        this.paymentsList[0].bankAccountId =
                            this.companyDetails.profile.vatBankAccount.id;
                    } else if (this.bankAccounts?.length) {
                        this.paymentsList[0].bankAccountId = this.bankAccounts[0].id;
                    }
                }
            }
        },
    })
    companyDetails = {
        id: "",
        profile: {
            vatBankAccount: {
                id: "",
                iban: "",
                bic: "",
            },
        },
    };

    @Apollo({
        query: BANK_ACCOUNTS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.bankAccounts?.length) {
                    for (const ba of data.bankAccounts) {
                        if (ba.iban?.length > 0 && ba.bic?.length > 0) {
                            this.bankAccounts.push(ba);
                        } else {
                            this.incompleteBankAccounts.push(ba);
                        }
                    }
                }
            }
        },
    })
    bankAccounts = [];

    async beforeMount() {
        await this.instanciateDeclaration();
        this.selectedTaxFormIndex = 0;
    }

    async instanciateDeclaration() {
        this.loaded = false;
        if (this.id) {
            this.declarationId = this.id;
            // to delete assistVatMode and autoVatMode on data before to send
            if (this.autoVatMode || this.assistVatMode) {
                this.needSave = true;
            }
        } else {
            this.needSave = true;
        }
        if (!this.declaration) {
            if (this.companyId && this.accountingPeriodId && this.fileMillesim) {
                this.declaration = await DeclarationFront.instanciate(
                    this.companyId,
                    this.accountingPeriodId,
                    this.declarationId,
                    this.cerfaNumber,
                    this.fileMillesim,
                    this.startDate,
                    this.endDate,
                );
                if (this.declarationId) {
                    this.declaring = this.declaration.declaring;
                }
                if (this.assistVatMode || this.autoVatMode) {
                    this.declaration.fillSheetsFromVatAssistAndAuto(
                        this.previousVatCredit,
                        this.assistVatItems,
                        this.autoVatItems,
                    );
                }
                if (this.assistDasTwoMode) {
                    await this.declaration.fillSheetsFromDasTwoAssist(
                        this.assistDasTwoDeclaring,
                        this.assistDasTwoBeneficiaries,
                    );
                }
                if (!this.declarationId && this.declaration.autoDeposit) {
                    this.autoDepositValidationDialog = true;
                }
            } else {
                debugger;
                this.backToTaxForms();
                return;
            }
        }
        this.getSheets();
        this.loaded = true;
    }

    async save() {
        // SPECIFIC
        // 2561
        // save declaring
        if (this.cerfaNumber === "2561") {
            this.declaration.declaring = {
                name: this.declaring.name,
                email: this.declaring.email,
                phone: this.declaring.phone,
                cityInseeCode: this.declaring.cityInseeCode,
                postOfficeDistributor: this.declaring.postOfficeDistributor,
                siret: this.company?.siret,
                legalCategory: this.declaring.legalCategory,
            };
        }
        //
        if (this.declarationId) {
            await this.declaration.saveOrDuplicateDeclaration(
                this.declarationId,
                this.assistVatItems,
                this.autoVatItems,
                false,
                false,
                null,
                null,
            );
            if (!window.location.href.includes("declaration2")) {
                this.$router.replace({
                    name: "declaration2",
                    params: { id: this.declarationId },
                    replace: true,
                });
            }
        } else if (this.cerfaNumber && this.accountingPeriodId) {
            this.declarationId = await this.declaration.saveOrDuplicateDeclaration(
                "",
                this.assistVatItems,
                this.autoVatItems,
                false,
                false,
                null,
                null,
            );
            // to have sheet IDs in case of next save without exiting
            await this.declaration.getDeclaration();
            await this.declaration.generateSheets();
            this.getSheets();
            //
            // store vat items to keep after router replace
            storeVatItems(
                this.autoVatItems,
                this.assistVatItems,
                this.previousVatCredit,
                this.$store,
            );
            this.$router.replace({
                name: "declaration2",
                params: { id: this.declarationId },
                replace: true,
            });
        } else {
            debugger;
            return;
        }
        this.needSave = false;
    }

    async generate() {
        const accountingFirm = await getAccountingFirmFromUser(this.$apollo, this.currentUser);
        if (accountingFirm?.id) {
            try {
                await this.$apollo.mutate({
                    mutation: GENERATE_DECLARATION,
                    variables: {
                        declarationID: this.declarationId,
                        companyID: this.companyId,
                        accountantID: accountingFirm.id,
                        extraData: this.extraData,
                        paymentsList: this.amountToPay > 0 ? this.paymentsList : null,
                    },
                });
            } catch (e) {
                debugger;
                console.error("Generate declaration error:", e);
            }
            this.confirmDialogSend = false;
            this.backToTaxForms();
        }
    }

    async validateWithoutSendingToMTAE() {
        const accountingFirm = await getAccountingFirmFromUser(this.$apollo, this.currentUser);
        if (accountingFirm?.id) {
            try {
                await this.$apollo.mutate({
                    mutation: VALIDATE_DECLARATION_WITHOUT_SENDING_MTAE,
                    variables: {
                        declarationID: this.declarationId,
                        extraData: this.extraData,
                    },
                });
            } catch (e) {
                debugger;
                console.error("Validate declaration error:", e);
            }
            this.confirmWithoutSendingDialog = false;
            this.backToTaxForms();
        }
    }

    async reComputeAccountingLines() {
        if (this.declarationDB?.document?.status === "DELETED" && this.documentId) {
            // for a lightly deleted document only
            try {
                await this.$apollo.mutate({
                    mutation: RESTORE_DOCUMENT,
                    variables: {
                        id: this.documentId,
                        status: "VALIDATED",
                    },
                });
            } catch (e) {
                debugger;
                console.error("Restore document error:", e);
            }
        }
        // for a validated or lightly or definitely deleted document
        let data = null;
        try {
            data = await this.$apollo.mutate({
                mutation: UPDATE_DECLARATION_MO,
                variables: {
                    id: this.declarationId,
                },
            });
        } catch (e) {
            debugger;
            console.error("Update MO error:", e);
        }
        // for the reactivity
        if (data) {
            this.newDocumentId = data.data.updateDeclarationAccountingLines.documentId;
        }
    }

    async updateStatus() {
        try {
            await this.$apollo.mutate({
                mutation: UPDATE_DECLARATIONS_STATUS,
                variables: {
                    ids: [this.declarationId],
                },
            });
        } catch (e) {
            debugger;
            console.error("Update status error:", e);
        }
        this.backToTaxForms();
    }

    async duplicate() {
        try {
            await this.declaration.saveOrDuplicateDeclaration(
                "",
                null,
                null,
                false,
                false,
                null,
                null,
            );
        } catch (error) {
            console.error(error);
        }
        this.backToTaxForms();
    }

    async formToAdd(form: any, update: boolean = true) {
        if (form?.forms?.length) {
            for (let index = 0; index < form.forms.length; index++) {
                const f = form.forms[index];
                await this.formToAdd(f, index === form.forms.length - 1);
            }
            return;
        }
        const sheet = await this.declaration.addSheet(this.fileMillesim, form.cerfa);
        if (update) {
            if (sheet) {
                this.additionnalPageCreated(0);
            }
            this.addFormDialog = false;
        }
    }

    async deleteSheet() {
        await this.declaration.deleteSheet(this.sheetToDelete);
        this.getSheets();
        this.tabsRefreshKey++;
        this.toDeleteDialog = false;
    }

    // SPECIFIC
    // 2561
    // add beneficiary
    async addBeneficiary() {
        await this.declaration.addSheet(this.fileMillesim, "2561", false);
        await this.declaration.addSheet(this.fileMillesim, "2561BIS", false);
        await this.declaration.addSheet(this.fileMillesim, "2561TER");
        this.additionnalPageCreated(0);
    }

    // SPECIFIC
    // 2561
    // print 2561TER
    async printForms() {
        let toPrintElement = "";

        const filteredSheets = this.sheets.filter((sheet) => sheet._form?.form?.name === "2561TER");

        for (const sheet of filteredSheets) {
            toPrintElement += await sheet.getStaticHtml("png");
            toPrintElement += "<div style='page-break-after: always;'></div>";
        }

        if (toPrintElement) {
            const WinPrint = window.open(
                "",
                "",
                "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0",
            );

            WinPrint.document.write(`<!DOCTYPE html>
            <html>
                <head>
                    <title>2561TER - ${this.company.name} - ${moment(this.endDate).format(
                        "DDMMYYYY",
                    )}</title>
                    <style>
                        body {
                            font-family: "Roboto", sans-serif;
                            font-size: 12px;
                            margin: 5mm;
                            -webkit-print-color-adjust: exact !important;
                            color-adjust: exact !important;
                            print-color-adjust: exact !important;
                        }
                    </style>
                </head>
                <body>
                    ${toPrintElement}
                </body>
            </html>`);

            WinPrint.onload = () => {
                WinPrint.print();
            };

            WinPrint.document.close();

            const checkWindowClosed = setInterval(() => {
                if (WinPrint.closed) {
                    clearInterval(checkWindowClosed);
                }
            }, 100);
        }
    }

    beforeDestroy() {
        // to have refreshed data at the declaration reopening
        apolloClient.resetStore();
    }

    back() {
        if (this.assistVatMode || this.autoVatMode || this.assistDasTwoMode) {
            return this.$emit("back");
        }
        this.backToTaxForms();
    }

    getSheets() {
        if (this.declaration?.sheets) {
            this.sheets = this.declaration.sheets;
        } else {
            this.sheets = [];
        }
        if (this.declaration?.sheetNames) {
            this.sheetNames = this.declaration.sheetNames;
        } else {
            this.sheetNames = [];
        }
    }

    additionnalPageCreated(index: number) {
        this.getSheets();
        this.tabsRefreshKey++;
        this.selectedTaxFormIndex = index;
        this.needSave = true;
    }

    onTaxFormChanged() {
        this.needSave = true;
        this.declaration.updateDependencies(); // otherwise links between sheets are not fully functional (e.g. '@:' functions)
        this.declaration.update();
    }

    validAndPay() {
        // SPECIFIC
        // 2561
        // declaring condition
        if (this.cerfaNumber === "2561" && !this.declaringIsFullyFilled) {
            this.declaringAlertDialog = true;
        } else {
            this.paymentsList[0].amount = this.amountToPay;
            this.confirmDialogSend = true;
        }
    }

    newCommonFormatCurrency(value, option) {
        return newCommonFormatCurrency(value, option);
    }

    isItemDisabled(item) {
        return !!this.paymentsList.find((pl) => pl.bankAccountId === item.id);
    }

    addPaymentLine() {
        this.paymentsList.push({ bankAccountId: "", amount: 0 });
    }

    deletePaymentLine(index) {
        this.paymentsList.splice(index, 1);
    }

    confirm() {
        this.miscellaneousOperationDialog = true;
        this.confirmDialogMiscellaneousOperation = false;
    }

    downloadXMLFile() {
        if (this.xml) {
            const blob = new Blob([this.xml], { type: "text/xml" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "fichier.xml";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        }
    }

    isMandatoryForm(cerfaNumber: string) {
        return this.declaration?.isMandatoryForm(cerfaNumber);
    }

    openDialogToDeleteSheetForm(name: string, index: number) {
        this.sheetToDelete = { name, index };
        this.toDeleteDialog = true;
    }

    getShowTrashButton(name: string): boolean {
        if (this.isSent) {
            return false;
        }
        // SPECIFIC
        // 2561
        // trash condition
        if (this.cerfaNumber === "2561") {
            return false;
        }
        if (this.isMandatoryForm(name)) {
            return false;
        }
        return true;
    }

    backToTaxForms() {
        this.$router.push({ name: "taxForms" });
    }

    fillAutoDepositInDeclaration() {
        this.autoDepositValidationDialog = false;
        this.declaration.fillAutoDeposit();
        this.formsRefreshKey++;
    }
}

export default toNative(DeclarationManager);
</script>
<style>
.line-clamp-5 {
    overflow: hidden;
    display: -webkit-box;
    line-clamp: 5 !important;
    -webkit-line-clamp: 5 !important;
    -webkit-box-orient: vertical;
}
</style>
